// src/components/AccessControl/AccessControl.tsx
// ✅ VERSÃO FINAL COM BOTÃO FUNCIONAL

import React, { ReactNode } from 'react';
import LockedOverlay from '../dashboard/LockedOverlay';
import './AccessControl.css';

export interface AccessControlProps {
    entityType: 'cycle' | 'deck' | 'subdeck';
    entityId: string;
    entityName?: string;
    isInterdicted: boolean;
    isPurchased: boolean;
    isFree?: boolean;
    isAdmin: boolean;
    isEditor?: boolean;
    onUpgradeClick: (e?: React.MouseEvent) => void;
    onInterdictedClick?: (e: React.MouseEvent) => void;
    children: ReactNode;
    className?: string;
    onNavigate?: () => void;
}

const AccessControl: React.FC<AccessControlProps> = ({
    entityType,
    entityId,
    entityName,
    isInterdicted,
    isPurchased,
    isFree = false,
    isAdmin,
    isEditor = false,
    onUpgradeClick,
    onInterdictedClick,
    children,
    className = '',
    onNavigate
}) => {
    const canBypassInterdiction = isAdmin || isEditor;
    const shouldShowInterdiction = isInterdicted && !canBypassInterdiction;
    const shouldShowLocked = !isInterdicted && !isFree && !isPurchased && !isAdmin;
    const hasAccess = canBypassInterdiction || (!isInterdicted && (isFree || isPurchased));

    const getOpacity = (): number => {
        if (isInterdicted) return 0.5;
        if (!isFree && !isPurchased && !isAdmin) return 0.5;
        return 1;
    };

    const handleClick = (e: React.MouseEvent) => {
        const target = e.target as HTMLElement;

        if (target.closest('.cycle-actions-btns') ||
            target.closest('.admin-actions-header')) {
            return;
        }

        if (canBypassInterdiction && onNavigate) {
            onNavigate();
            return;
        }

        if (shouldShowInterdiction) {
            e.stopPropagation();
            e.preventDefault();
            if (onInterdictedClick) {
                onInterdictedClick(e);
            }
            return;
        }

        if (shouldShowLocked) {
            e.stopPropagation();
            e.preventDefault();
            onUpgradeClick(e);
            return;
        }

        if (hasAccess && onNavigate) {
            onNavigate();
        }
    };

    return (
        <div
            className={`access-control ${className}`}
            style={{
                opacity: getOpacity(),
                cursor: hasAccess ? 'pointer' : 'not-allowed',
                position: 'relative'
            }}
            onClick={handleClick}
        >
            {children}

            {shouldShowLocked && (
                <LockedOverlay
                    onUpgradeClick={onUpgradeClick}
                    entityType={entityType === 'cycle' ? 'cycle' : 'deck'}
                />
            )}
        </div>
    );
};

export default AccessControl;